export enum DeliveryOption {
    STORE_PICKUP = 'STORE_PICKUP',
    FOXPOST = 'FOXPOST',
    MPL = 'MPL',
    ALL = 'ALL'
}
